package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Simulation_line(
  public val id: String,
  public val simulation_id: String,
  public val label: String,
  public val expression: String,
  public val order_index: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
